<template>
  <div>
    <!--基础信息-->
    <div class="card wallet-statistics">
      <div>
        <p>今日交易额</p>
        <span class="font2"><em style="padding-right: 2px">$</em><b>{{$formatWithCommas(todayVol)}}</b></span>
      </div>
      <div class="border-lr">
        <p>Gas 余额</p>
        <span class="font2"><em style="padding-right: 2px">$</em><b>{{$formatDecimals(balance)}}</b></span>
      </div>
      <div>
        <p>已获 Alpha 积分</p>
        <span class="font2"><b>{{allJs}}</b><em style="padding-left: 2px">积分</em></span>
      </div>
    </div>

    <div class="card wallet-card">
      <div class="wallet-address">
        <span class="font2">{{ formatAddress(accountInfo) }}</span>
        <div class="chain">
          <i class="dot"></i>
          <span>BNB Smart Chain</span>
        </div>
      </div>
      <div class="wallet-label font2">Wallet1</div>
    </div>

    <!-- 签名卡片 -->
    <div class="card sign-card">
      <p class="sign-title">花费</p>
      <div class="sign-content" v-if="selectedList && defaultPath">
        <!-- 买入时显示selectedList代币，卖出时显示defaultPath代币 -->
        <div class='chain-logo'>
          <img class="logo" :src="transactionType === 'buy' ? selectedList.imageUrl : defaultPath.imageUrl" alt="">
          <img class="chain" src="~@/assets/imgs/logo/WBNB.png" alt="">
        </div>
        <div>
          <p class="font2" style="color:#54BC67;" v-if="transactionType === 'buy'">
            -{{tradeAmount}} {{selectedList.symbol}}
          </p>
          <p class="font2" v-else style="color: #000">
            -{{ $formatDecimals(secondCalculatedValue) }} {{ defaultPath.symbol }}
          </p>
          <span class="font2">≈${{ $formatDecimals(firstCalculatedValue) }}</span>
        </div>
      </div>
      <div style="margin: 15px 0;border-top:0.5px solid rgba(0, 0, 0, 0.1);"></div>
      <p class="sign-title">预计可收</p>
      <div class="sign-content" v-if="selectedList && defaultPath">
        <!-- 买入时显示defaultPath代币，卖出时显示selectedList代币 -->
        <div class='chain-logo'>
          <img class="logo" :src="transactionType === 'buy' ? defaultPath.imageUrl : selectedList.imageUrl" alt="">
          <img class="chain" src="~@/assets/imgs/logo/WBNB.png" alt="">
        </div>
        <div>
<!--          <p class="font2" style="color: #000">-->
<!--            +{{ transactionType === 'buy' ? $formatDecimals(secondCalculatedValue) : tradeAmount }}-->
<!--            {{ transactionType === 'buy' ? defaultPath.symbol : selectedList.symbol }}-->
<!--          </p>-->


          <p class="font2" style="color:#000;" v-if="transactionType === 'buy'">
            +{{ $formatDecimals(secondCalculatedValue) }} {{ defaultPath.symbol }}
          </p>
          <p class="font2" v-else style="color: #54BC67">
            +{{tradeAmount}} {{selectedList.symbol}}
          </p>

          <span class="font2">≈${{ $formatDecimals(firstCalculatedValue) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: "wallet_card",
    props: ["transactionType","tradeAmount", "selectedList", "defaultPath","secondCalculatedValue","firstCalculatedValue","balance","allJs","todayVol","todayTradeList"],
    computed: {
      ...mapState([
        "accountInfo"
      ])
    },
    methods:{
      // 格式化地址显示
      formatAddress(address) {
        if (!address) return '';
        return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
      },
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
</style>